// extracted by mini-css-extract-plugin
module.exports = {"link":"link___4pQGO","google":"google___2hI3R"};